<template>
    <div>
        <b-overlay
                :show="loading"
                spinner-variant="primary"
                spinner-type="grow"
                rounded="sm"
        >
            <b-alert
                    variant="primary"
                    class="mb-2"
                    :show="true"
            >
                <div class="alert-body">
                    <feather-icon
                            icon="InfoIcon"
                            class="mr-50"
                    />
                    A vízterületek törzsadat kezelése a HORINFO szakrendszerben történik. Vízterületet létrehozni,
                    elnevezését, víztérkódját módosítani csak a HORINFO szakrendszerben lehetséges. A HORINFO vízterület
                    adatokat a rendszer {{ updateFrequency }} naponként automatikusan átveszi, de van lehetőség a
                    frissítés azonnali elvégzésére is.<br>
                    <b-button
                            class="mt-2"
                            size="sm"
                            variant="primary"
                            @click.stop="$router.push({ name: 'horinfo-sync'})"
                    >HORINFO adatfrissítés
                    </b-button>
                </div>
            </b-alert>

            <div class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <label class="mr-1">Keresés</label>
                        <b-form-input
                                v-model="searchTerm"
                                placeholder="Keresés..."
                                type="text"
                                class="d-inline-block"
                                @input="globalSearch"
                        />
                    </div>
                </b-form-group>
            </div>

            <!-- table -->
            <vue-good-table
                    mode="remote"
                    :columns="columns"
                    :rows="rows"
                    :rtl="direction"
                    :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
                    :sort-options="{
          enabled: true,
          initialSortBy: sortBy
        }"
                    @on-row-click="onRowClick"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
            >
                <div slot="emptystate">
                    <div class="vgt-center-align vgt-text-disabled">
                        {{ $t('table.list.empty') }}
                    </div>
                </div>
                <template
                        slot="table-row"
                        slot-scope="props"
                >

                    <!-- Column: Name -->
                    <span
                            v-if="props.column.field === 'name'"
                    >
                {{ props.row.name }}
              </span>

                    <span
                            v-else-if="props.column.field === 'active'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.active ? 'Igen' : 'Nem' }}</span>
              </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">

                  <b-button
                          v-b-tooltip.hover
                          title="Rekordlista szűrése erre a vízterületre"
                          size="sm"
                          variant="info"
                          class="ml-1"
                          @click.stop="searchRecordCatch(props.row.id)"
                  >
                    <feather-icon
                            icon="SearchIcon"
                    />
                  </b-button>

                    <b-button
                            v-b-tooltip.hover
                            title="Megtekintés"
                            size="sm"
                            variant="primary"
                            class="ml-1"
                            @click.stop="$router.push({ name: 'show-water', params: { id: props.row.id }})"
                    >
                    <feather-icon
                            icon="EyeIcon"
                    />
                  </b-button>
              </span>

                    <!-- Column: Common -->
                    <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
                </template>

                <!-- pagination -->
                <template
                        slot="pagination-bottom"
                        slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ ((page - 1) * pageLength) + 1 }} +
            </span>
                            <b-form-select
                                    v-model="pageLength"
                                    :options="pages"
                                    class="mx-1"
                                    @change="handlePageChange"
                            />
                            <span class="text-nowrap "> a {{ dataFromServer.total }} találatból </span>
                        </div>
                        <div>
                            <b-pagination
                                    :value="1"
                                    :total-rows="dataFromServer.total"
                                    :per-page="dataFromServer.per_page"
                                    first-number
                                    last-number
                                    align="right"
                                    prev-class="prev-item"
                                    next-class="next-item"
                                    class="mt-1 mb-0"
                                    @change="handleChangePage"
                            >
                                <template #prev-text>
                                    <feather-icon
                                            icon="ChevronLeftIcon"
                                            size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                            icon="ChevronRightIcon"
                                            size="18"
                                    />
                                </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-overlay>
    </div>
</template>

<script>
import {
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    VBTooltip,
    BAlert, BOverlay,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store'

export default {
    components: {
        BOverlay,
        BAlert,
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BButton,
        VBTooltip,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            role: 'water',
            pageLength: 10,
            dir: false,
            loading: false,
            pages: ['10', '20', '50'],
            columns: [
                {
                    label: this.$t('form.id'),
                    field: 'id',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Azon. szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: this.$t('form.name'),
                    field: 'name',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Név szerinti szűrés',
                    },
                },
                {
                    label: 'Víztérkód',
                    field: 'water_code',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Víztérkód szerinti szűrés',
                    },
                },
                {
                    label: 'Aktív',
                    field: 'active',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Aktív állapot szerinti szűrés',
                        filterDropdownItems: [
                            {value: true, text: 'Igen'},
                            {value: false, text: 'Nem'}
                        ]
                    },
                },
                {
                    label: 'Rekordfogások száma',
                    field: 'record_catch_count',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Rekordfogások száma',
                    },
                },
            ],
            rows: [],
            page: 1,
            dataFromServer: [],
            filterData: [],
            searchTerm: '',
            sortBy: {
                field: 'id',
                type: 'desc',
            },
            columnFilters: [],
            updateFrequency: '',
            lastUpdateDate: '',
        }
    },
    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        let storedPageLength = localStorage.getItem('pageLength')
        if (storedPageLength) {
            this.pageLength = storedPageLength
        }

        let storedSearchTerm = localStorage.getItem('waterSearchTerm')
        if (storedSearchTerm) {
            this.searchTerm = storedSearchTerm
        }

        let storedColumnFilters = localStorage.getItem('waterColumnFilters')
        if (storedColumnFilters) {
            this.columnFilters = JSON.parse(storedColumnFilters)
            Object.keys(this.columnFilters).forEach(key => {
                const value = this.columnFilters[key]
                const foundIndex = this.columns.findIndex(col => col.field === key)

                if (foundIndex !== -1) {
                    this.$set(this.columns[foundIndex].filterOptions, 'filterValue', value)
                }
            })
        }

        const actions = [
            {
                label: this.$t('table.header.actions'),
                field: 'action',
                sortable: false,
                width: '15rem',
            },
        ]

        this.columns = [...actions, ...this.columns]

        this.initEntities()
    },
    methods: {
        initEntities() {
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }

            this.$store.dispatch('fetchWaters', searchParams).then(response => {
                this.rows = response.data.entities.data
                this.dataFromServer = response.data.entities
                this.page = this.dataFromServer.current_page
                this.pageLength = parseInt(this.dataFromServer.per_page)
                this.updateFrequency = response.data.updateFrequency
                this.lastUpdateDate = response.data.lastUpdateDate
            })
        },
        onRowClick(params) {
            this.$router.push({name: 'show-water', params: {id: params.row.id}})
        },
        handleChangePage(page) {
            this.page = page
            this.initEntities()
        },
        handlePageChange(active) {
            this.pageLength = active
            localStorage.setItem('pageLength', active)
            this.page = 1
            this.handleChangePage()
        },
        globalSearch(params) {
            this.page = 1
            this.query = params.searchTerm
            localStorage.setItem('waterSearchTerm', this.searchTerm)
            this.initEntities()
        },
        onSortChange(params) {
            this.page = 1
            this.sortBy = params[0]
            this.initEntities()
        },
        onColumnFilter(params) {
            this.page = 1
            this.columnFilters = params.columnFilters
            localStorage.setItem('waterColumnFilters', JSON.stringify(this.columnFilters))
            this.initEntities()
        },
        searchRecordCatch(id) {
            let routeData = this.$router.resolve({name: 'record-catches', query: {water_id: id}});
            window.open(routeData.href, '_blank');
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
